import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Container, Grid, InputAdornment, IconButton } from "@mui/material";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import ChangePasswordController from "../controller/ChangePasswordController";
import CustomizedSnackbars from "../components/Alert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../css/style.css";

const INITIAL_FORM_STATE = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const FORM_VALIDATION = Yup.object().shape({
  oldPassword: Yup.string()
    .trim()
    .min(8)
    .max(20)
    .required("Old password is required"),
  newPassword: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .min(8)
    .max(20)
    .required("New password is required"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("newPassword"), null],
      "New password and confirm password must match"
    )
    .required("Confirm password is required"),
});

const changePasswordController = new ChangePasswordController();
const ChangePassword = () => {
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [togglePasswordOld, setTogglePasswordOld] = useState(true);
  const [togglePasswordNew, setTogglePasswordNew] = useState(true);
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify?.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const Submit = (dataValue) => {
    // dataValue.tenantId = tenantId;
    dataValue.userId = userId;
    changePasswordController
      .Update(dataValue, token)
      .then((response) => {
        if (response.status === 200)
          showAlert("success", response.data.message);
        else if (response.data.status === 400)
          showAlert("error", response.data.message);
        else if (response?.status === 500)
          showAlert("error", response?.response?.data?.message);
      })
      .catch((error) => {
        showAlert("error", "Oops Something went wrong");
      });
  };

  return (
    <Grid container>
      <Grid className="breadcrumb-section">
        <Grid className="breadcrumb-container">
          <Grid className="Mui-li">
            <nav className="Mui-nav" aria-label="breadcrumb">
              <ol className="">
                <li className="MuiBreadcrumbs-li">
                  <h6 className="breadsub">Home</h6>
                </li>
                <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                  /
                </li>
                <li className="MuiBreadcrumbs-li">
                  <h6>Change Password</h6>
                </li>
              </ol>
            </nav>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className="formBg">
        <Container maxWidth="md" className="formClwidth">
          <div>
            <Formik
              enableReinitialize
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values) => Submit(values)}
            >
              {({ handleSubmit }) => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Controls.Textfield
                        name="oldPassword"
                        label="Old password"
                        type={togglePasswordOld ? "password" : "string"}
                        inputProps={{ maxLength: 20 }}
                        autoFocus
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setTogglePasswordOld((toggle) => !toggle)
                                }
                              >
                                {togglePasswordOld ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <Controls.Textfield
                        name="newPassword"
                        label="New password"
                        type={togglePasswordNew ? "password" : "string"}
                        inputProps={{ maxLength: 20 }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setTogglePasswordNew((toggle) => !toggle)
                                }
                              >
                                {togglePasswordNew ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Controls.Textfield
                        name="confirmPassword"
                        label="Confirm password"
                        type="password"
                        inputProps={{ maxLength: 20 }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) handleSubmit(e);
                        }}
                      />
                    </Grid>

                    <Grid item xs={4} md={2} className="marginAuto">
                      <Controls.Button>Submit</Controls.Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
            {alert?.counter > 0 && (
              <CustomizedSnackbars
                status={alert?.counter}
                msg={alert?.msg}
                type={alert?.type}
              />
            )}
          </div>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;
